import { sceneNotes } from "@/mocks/home";

export default function Scene() {
  return (
    <section id="scene" className="mx-auto max-w-6xl scroll-mt-24 px-4 pt-16 md:px-6 md:pt-24">
      <div className="border-b border-line pb-5">
        <p className="text-xs uppercase tracking-[0.2em] text-muted">Field · 第一现场</p>
        <h3 className="font-display mt-2 text-2xl font-bold tracking-tight text-ink md:text-3xl">
          我们守在原地的样子
        </h3>
      </div>

      <div className="mt-12 flex flex-col gap-16 lg:gap-20">
        {sceneNotes.map((note, i) => (
          <div
            key={note.id}
            className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14"
          >
            <div className={`${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-map-pin-2-line text-[13px] text-marker" /> {note.place}
                </span>
                <span className="tabular-nums">{note.time}</span>
              </div>
              <h4 className="font-display mt-4 text-2xl font-black leading-snug tracking-tight text-ink md:text-[1.9rem]">
                {note.title}
              </h4>
              <p className="mt-5 text-[15px] leading-8 text-ink/80">{note.body}</p>
              <blockquote className="relative mt-7 border-l-2 border-accent pl-5 text-[15px] leading-7 text-accent-deep">
                <i className="ri-double-quotes-l absolute -left-1 -top-5 text-3xl text-line" />
                {note.note}
              </blockquote>
            </div>

            <figure className={`group relative overflow-hidden rounded-lg bg-paper-2 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <div className="relative h-[300px] w-full overflow-hidden sm:h-[360px] lg:h-[400px]">
                <img
                  src={note.img.src}
                  alt={note.img.alt}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <figcaption className="border-t border-line px-5 py-3 text-xs text-muted">
                {note.img.alt} · 栏目示意
              </figcaption>
            </figure>
          </div>
        ))}
      </div>
    </section>
  );
}